import React, { useEffect } from "react";
import IsLogin from "../../utilities/functions/isLogin";
import { ReactComponent as PazirexLogo } from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import { ReactComponent as NotFoundImage } from "./../../assets/images/404.svg";
import { Link } from "react-router-dom";

const Page404 = () => {
  const isMobile = window.innerWidth >= 992 ? false : true;

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      if (loggedIn === false || loggedIn === "error api") {
        localStorage.clear();
      }
    };

    checkLoginStatus();
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center page-404 mx-auto">
      <PazirexLogo className="mt-lg-4 my-auto logo-img" />
      <NotFoundImage className="my-4 notfound-img" />
      <p className="fs-16 fw-medium color-bootstrap-gray-900 w-fit mb-2">
        {"متاسفانه صفحه مورد نظر یافت نشد :("}
      </p>
      <p className="fs-14 fw-normal color-bootstrap-gray-700 w-fit mb-4">
        {"پذیرکس این صفحه رو پیدا نکرد!"}
      </p>
      <Link
        className="btn btn-blue-300 w-fit px-5 py-2 fs-14 fw-medium my-auto"
        to="/"
      >
        بازگشت به خانه
      </Link>
    </div>
  );
};

export default Page404;
